
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit/debitCard",
      function () {
        return require("private-next-pages/credit/debitCard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit/debitCard"])
      });
    }
  